<template>
  <div class="cilinder-configurator">
    <button class="view-cart-button" @click="setCartState" v-if="!isMagento">
      {{ $t('cart.button_text') }}
    </button>

    <transition name="fade" mode="out-in">
      <div class="cart-dropdown"
           v-if="isCartOpen"
           :class="{'active': isCartOpen}">
        <order-cart @close="setCartState"></order-cart>
      </div>
    </transition>

    <decision-aid
      @close="$store.commit('preference/openAid', {type: ''})"
      v-if="openModal.type !== ''"
      :type="openModal.type"
      :tab="openModal.tab"
      :subtype="openModal.subtype"
    ></decision-aid>
    <div class="container-x">
      <div class="d-flex flex-nowrap overflow-auto">
        <template v-if="device === 'mobile'">
          <sidebar :title="$t('cylinder.configurator.menu')">
            <div id="cilinder-container">
              <cilinder-calculator ref="calculator"></cilinder-calculator>
            </div>
          </sidebar>
        </template>
        <template v-else>
          <div id="cilinder-container">
            <cilinder-calculator ref="calculator"></cilinder-calculator>
          </div>
        </template>
        <div class="decision-container" :class="{ mobile: device === 'mobile' }">
          <measurements-menu></measurements-menu>
          <cilinder-list @openModal="showModal = true" ref="cilinder-picker"></cilinder-list>
        </div>
      </div>
    </div>
    <popup-shopping-cart :generator="$t('cart.cylinder')" @close="showModal = false" v-if="showModal"></popup-shopping-cart>
  </div>
</template>

<script>
import Calculator from './Calculator';
import DecisionAid from './DecisionAid';
import CilinderList from "./CilinderList";
import MeasurementsMenu from "./MeasurementsMenu";
import Order from "../step2/order/Order";
import Sidebar from "../sidebar/Sidebar"

import {mapGetters, mapState} from 'vuex';
import PopupShoppingCart from "@/components/popup/PopupShoppingCart";
import OrderCart from "@/components/step2/order/OrderCart.vue";

export default {
  name: "Configurator",

  components: {
    OrderCart,
    Order,
    MeasurementsMenu,
    'cilinder-calculator': Calculator,
    'decision-aid': DecisionAid,
    'cilinder-list': CilinderList,
    Sidebar,
    PopupShoppingCart,
  },

  data() {
    return {
      showModal: false,
    }
  },

  computed: {
    ...mapGetters( {
      openAid: 'preference/getModal',
      device: 'getDevice',
      isMagento: 'preference/isMagento',
    }),
    ...mapState({
      isCartOpen: state => state.cart.isCartOpen,
    }),
    openModal: {
      get() {
        return this.openAid;
      },
      set(val) {
        this.$store.commit('preference/openAid', val)
      }
    },
  },

  methods: {
    setCartState() {
      if (this.isCartOpen) {
        this.$store.commit('cart/setCartState', false);
        return;
      }

      this.$store.commit('cart/setCartState', true);
    },
  },
}
</script>

<style scoped lang="scss">
.cilinder-configurator {
  background-color: #F5F5F5;
  position: relative;

  .view-cart-button {
    position: sticky;
    right: 0;
    top: -50px;
    left: 100%;
    z-index: 8;
    background: #FFFFFF;
    color: #71BC03;
    font-weight: 600;
    border: 2px solid #71BC03;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    margin-bottom: 20px;

    &:hover {
      background: rgba(#71BC03, 10%);
    }

    &:focus {
      outline: none;
    }
  }

  .cart-dropdown {
    z-index: 8;
    background: white;
    min-width: 420px;
    width: auto;
    position: absolute;
    top: 40px;
    right: 0;
    border-radius: 3px;
    padding: 20px;
    overflow: hidden;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .26) !important;

    @media only screen and (max-width: 512px) {
      right: 0;
      width: 100%;
      min-width: 100%;
    }
  }

  .decision-container {
    padding: 0 0 20px 25px;
    flex-grow: 1;

    &.mobile {
      width: 100%;
    }
  }
}

.magento {
  .cilinder-configurator {
    padding-top: 0;
    background-color: #FFF;
  }
}
</style>
